import { getUrlSlugByCardType } from '@zola/zola-ui/src/paper/cards/util/getCardUrl';
import { CardType, CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

import { Breadcrumb } from 'components/common/types';
import { isCustomizationStep } from '@zola/zola-ui/src/paper/cards/constants/customizationSteps';
import { getStepKey } from './getStepKey';

// Need to filter out invitation and rsvp envelope card types,
// as they don't have card settings or a urlSlug value
const { invitationEnvelope, rsvpEnvelope, ...cardTypes } = CARD_TYPE_MAP;
const CARD_TYPES_BY_SLUG = Object.values(cardTypes).reduce((acc, typeKey) => {
  const urlSlug = getUrlSlugByCardType(typeKey);
  if (urlSlug) {
    acc[urlSlug] = typeKey;
  }
  return acc;
}, {} as Record<string, CardType>);

const getCardTypeFromSlug = (slug: string) => (slug && CARD_TYPES_BY_SLUG[slug]) || null;

export const getStepFromPathname = (pathname: string, orderedSteps: Breadcrumb[]) => {
  const paths = pathname.split('/');
  const slug = paths[paths.length - 2];
  const stepId = paths[paths.length - 1];
  const cardType = getCardTypeFromSlug(slug);

  let currentStep;
  if (cardType) {
    // Find the step with matching type and id
    const stepKey = isCustomizationStep(stepId) && getStepKey(stepId, cardType);
    currentStep = orderedSteps.find(step => step.key === stepKey);
  } else {
    // Otherwise, find the first step with matching id
    currentStep = orderedSteps.find(step => step.id === stepId);
  }

  return currentStep;
};
